export const isIndustryCodeBlockedByOtherCondition = (
    code: string,
    selectedCodes: readonly string[],
    disabledCodes: readonly string[],
): boolean => disabledCodes.includes(code) && !selectedCodes.includes(code);
